import { Button } from "components/atoms/button/button";
import styled from "styled-components";
import { breakpoints } from "styles";

export const CardHeading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2hxl"]};
  line-height: 40px;
  color: ${({ theme }) => theme.colors.neutral[900]};
  margin: 0;
`;

export const CardSubheading = styled.h3`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 4px 0 12px 0;
  font-weight: 400;
  line-height: 24px;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
`;

export const DataSection = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  font-weight: 700;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.neutral[1000]};
  margin: 0 0 20px 0;
`;

export const DataGrid = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 48px;
  width: 100%;

  > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
  }
`;

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.span`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["xs"]};
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-weight: 400;
  line-height: 16px;
`;

export const Value = styled.span`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  color: ${({ theme }) => theme.colors.neutral[1000]};
  font-weight: 700;
  line-height: 20px;
`;

export const ProfileWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  @media ${breakpoints.tablet} {
    margin-top: 16px;
  }
`;

export const UpdateProfileCTA = styled(Button)`
  width: 100%;
  @media ${breakpoints.tablet} {
    width: auto;
  }
`;

export const SubmitProfileCTA = styled(Button)`
  width: 100%;
  @media ${breakpoints.tablet} {
    width: auto;
  }
`;
